import { useState } from "react";

export const useNearbySearch = () => {
  const [userLocation, setUserLocation] = useState(null);
  const [nearbyOnly, setNearbyOnly] = useState(false);

  const requestUserLocation = () => {
    if (typeof navigator === "undefined" || !navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      () => {
        setNearbyOnly(false);
      },
      { enableHighAccuracy: false, maximumAge: 1000 * 60 * 10, timeout: 5000 }
    );
  };

  const handleNearbyOnlyChange = (value) => {
    setNearbyOnly(value);
    if (value && !userLocation) requestUserLocation();
  };

  return {
    nearbyOnly,
    handleNearbyOnlyChange,
    userLocation,
  };
};
